<rspl-card>
  <mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
    <mat-tab label="Custom" />
    <mat-tab label="Recommended" />
  </mat-tab-group>
  <div fxFlex="100" fxLayout="row wrap" fxLayoutGap="10px" class="zones">
    <div fxFlex="100" fxLayoutAlign="end end">
      @if (filter.template_type === 'custom') {
        <button mat-raised-button class="primary-btn filled-btn custom-zone-btn" (click)="createNewZone()">Add Zone</button>
      }
    </div>
    @for (zone of zones; track zone) {
      <div
        [fxFlex]="100 / 3"
        fxFlex.lt-xl="50"
        fxFlex.lt-lg="100"
        class="zone-wrapper"
        fxLayoutAlign="space-between start"
        fxLayout="column"
        [ngClass]="{ custom: filter.template_type === 'custom', recommended: filter.template_type === 'recommended' }"
      >
        <div fxLayout="column" fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <span class="name">
              {{ zone.name }}
            </span>
            <div fxLayout="row" fxLayoutGap="5px">
              @if (filter.template_type === 'custom') {
                <button mat-icon-button (click)="editZone(zone)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="deleteZone(zone)">Delete</button>
                  <button mat-menu-item (click)="createZone(zone)">Duplicate</button>
                </mat-menu>
              } @else {
                <button mat-raised-button class="primary-btn custom-zone-btn" (click)="createZone(zone)">Save as Custom Zone</button>
              }
            </div>
          </div>
          <p>{{ zone.description }}</p>
        </div>
        <div fxLayout="column" fxLayoutGap="10px">
          <div>
            @if (zone.store_id) {
              <div class="specific">Store Specific Zone</div>
            }
            @if (zone.vehicle_id) {
              <div class="specific">Vehicle Specific Zone</div>
            }
          </div>
          <div fxLayout="column wrap" fxLayoutGap="2px">
            @for (zip of zone.zips; track zip) {
              <span class="zip">{{ zip }}</span>
            }
          </div>
          <div fxFlex="1" style="height: 180px; border-radius: 12px; overflow: hidden">
            <rspl-map
              style="height: 180px; max-height: 180px"
              [showZoom]="false"
              [showAddressSearch]="false"
              [showZips]="true"
              [selectedZips]="zone.zips"
              [height]="'180px'"
            />
          </div>
        </div>
      </div>
    }
  </div>
</rspl-card>
